import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { contactUsDelete, contactUsList } from 'apis/operation/contactUsApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import MainTable from 'components/table/MainTable';
import CapsuleButton from 'components/button/CapsuleButton';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import TableToolbar from 'components/table/TableToolbar';
import SearchDatePicker from 'components/search/SearchDatePicker';
import PublicState from 'components/etc/PublicState';
import { confirmState, contactType } from 'utils/constant';
import ContactUsUpdateModal from './ContactUsUpdateModal';
import RegisterButton from 'components/button/RegisterButton';
import SearchInputNoEvent from 'components/search/SearchInputNoEvent';
import { useTranslation } from 'react-i18next';
/**
 *
 * @returns {운영 - 문의사항 조회}
 */
const ContactUsList = () => {
  const { t } = useTranslation();
  const dateFormat = 'YYYY-MM-DD';
  const today = dayjs().format('YYYY-MM-DD');
  const thisMonth = dayjs().subtract(1, 'M').format('YYYY-MM-DD');
  const [visible, setVisible] = useState(false);
  const [searchWord, setSearchWord] = useState();
  const [searchDate, setSearchDate] = useState({
    search_start_date: thisMonth,
    search_end_date: today,
  });
  const [datas, setDatas] = useState();
  const [selectData, setSelectData] = useState();

  /// 검색-일자
  const handleSearchDate = (dates, dateStrings) => {
    if (!dates) {
      setSearchDate({
        ...searchDate,
        search_start_date: thisMonth,
        search_end_date: today,
      });
      return;
    }
    setSearchDate({
      search_start_date: dateStrings[0],
      search_end_date: dateStrings[1],
    });
  };

  const handleChangeWord = (e) => {
    setSearchWord(e.target.value);
  };

  const handleUpdateClick = (record) => () => {
    setSelectData(record);
    setVisible(true);
  };
  const handleDelete = (record) => async () => {
    // console.log(record);
    const res = await contactUsDelete(record?.inquiry_no);
    if (!res) {
      return false;
    }
    fetchData();
  };
  const fetchData = async (e) => {
    if (e.key !== 'Enter') {
      return;
    }
    const res = await contactUsList(searchDate, searchWord);
    setDatas(res);
  };

  const columnsOrigin = [
    {
      title: t('contact.table.createDate'),
      dataIndex: 'create_date',
      width: '5rem',
      sorter: (a, b) =>
        a.create_date.localeCompare(b.create_date, undefined, {
          sensitivity: 'base',
        }),
    },
    {
      title: t('contact.table.kind'),
      dataIndex: 'kind',
      width: '5rem',
      render: (text) =>
        contactType?.map((v) => v.value === text && <p>{v.text}</p>),
      filters: contactType,
      onFilter: (value, record) => record?.kind === value,
    },
    {
      title: t('contact.table.client'),
      dataIndex: 'client',
      width: '5rem',
    },
    {
      title: t('contact.table.state'),
      dataIndex: 'state',
      width: '5rem',
      render: (text) => <PublicState value={text} confirm={confirmState} />,
      filters: confirmState,
      onFilter: (value, record) => record?.state === value,
    },
    {
      title: t('contact.table.move'),
      dataIndex: 'move',
      width: '5rem',
      render: (text, record) => (
        <div>
          <CapsuleButton onClick={handleUpdateClick(record)}>
            {t('contact.table.viewDetail')}
          </CapsuleButton>
          <DeletePopConfirm
            title={t('contact.table.deleteConfirm')}
            onConfirm={handleDelete(record)}
          />
        </div>
      ),
    },
  ];
  useEffect(() => {
    fetchData().catch(console.log);
  }, []);
  return (
    <>
      <DefaultLayout>
        <TableToolbar>
          <div>
            <SearchDatePicker
              format={dateFormat}
              defaultPickerValue={[dayjs(thisMonth), dayjs()]}
              value={[
                dayjs(searchDate.search_start_date, dateFormat),
                dayjs(searchDate.search_end_date, dateFormat),
              ]}
              onChange={handleSearchDate}
            />
            <SearchInputNoEvent
              value={searchWord}
              onChange={handleChangeWord}
              placeholder={t('contact.header.inputPlaceHolder')}
              onKeyPress={fetchData}
            />
            <RegisterButton onClick={fetchData}>
              {t('contact.header.searchButton')}
            </RegisterButton>
          </div>
          <div></div>
        </TableToolbar>
        <MainTable columns={columnsOrigin} dataSource={datas} />
      </DefaultLayout>
      {/* 모달 */}
      {visible && (
        <ContactUsUpdateModal
          visible={visible}
          setVisible={setVisible}
          record={selectData}
          fetchData={fetchData}
        />
      )}
    </>
  );
};

export default ContactUsList;
